export const LOAD_GROUPS = "bonfire/lookups/LOAD_GROUPS";
interface LoadGroupsAction {
  type: typeof LOAD_GROUPS;
}

export const LOAD_GROUPS_SUCCESS = "bonfire/lookups/LOAD_GROUPS_SUCCESS";
interface LoadGroupsSuccessAction {
  type: typeof LOAD_GROUPS_SUCCESS;
  result: any; // TODO: What is this?
}

export const LOAD_GROUPS_FAIL = "bonfire/lookups/LOAD_GROUPS_FAIL";
interface LoadGroupsFailAction {
  type: typeof LOAD_GROUPS_FAIL;
  error: any; // TODO: This could be anything TBH
}

export type LookupAction =
  | LoadGroupsAction
  | LoadGroupsFailAction
  | LoadGroupsSuccessAction;
